import React from 'react';
import { Link, Button } from '@mui/material';

export const ListYourVenueLink = () => {
  return (
    <Button
      component={Link}
      href="https://www.perfectvenue.com/"
      target="_blank"
      sx={{
        color: 'text.primary',
      }}
    >
      List your venue
    </Button>
  );
};
